module.exports = __webpack_public_path__ + "img/Iivaara_logo1.6ae95cf1.png";